import React from 'react'

export default function FormHeading({ style, heading }) {
    // bg-[#151B54]
    return (
        <div className={`w-100 my-2 p-1 px-2    ${style ? style : 'bg-[#800000]  text-white'}    font-bold`}>{heading}</div>
    )
}
